import { Outlet } from "@tanstack/react-router"
import { useConversationsResponsesQuery } from "modules/conversations/hooks/useConversationsResponsesQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSortBy } from "modules/shared/hooks/useSortBy"
import { Route } from "routes/_base/_auth/campaigns/$id/activity/route"
import { GetConversationsResponsesSortFields } from "schema"
import { CampaignResponsesFilter } from "./Filter"
import { CampaignResponsesTable } from "./Table"

const ITEMS_PER_PAGE = 40

export const CampaignResponses = () => {
  const search = Route.useSearch()
  const { id } = Route.useParams()
  const fullPath = "/campaigns/$id/activity"

  const { count, page, setCount, setPage, totalPages } = usePagination({
    search,
    fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { onSort, sortBy } = useSortBy<typeof GetConversationsResponsesSortFields>({
    search,
    fullPath,
    fields: GetConversationsResponsesSortFields,
  })

  const { data, isPending } = useConversationsResponsesQuery({
    query: {
      filterBy: {
        campaignId: id,
        avoidUnderlying: true,
        ...search.filterBy,
      },
      query: search.query,
      sortBy,
      page,
      total: ITEMS_PER_PAGE,
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <>
      <CampaignResponsesFilter />
      <CampaignResponsesTable
        data={data ?? []}
        isPending={isPending}
        search={search}
        onSort={onSort}
      />
      <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} count={count} />
      <Outlet />
    </>
  )
}
